import React from 'react'

const HiringDevelopers = ({ data }) => {
    return (
        <div>
            <h4 className="heading">{data?.heading}</h4>
            <div>
                {data?.listing?.length > 0 && (
                    data.listing.map((li, liIndex) => {
                        return (<div key={liIndex}>
                            <h5><b>{li?.title}</b></h5>
                            {li?.paragraph?.map((para, paraIndex) => {
                                return <div key={paraIndex}>
                                    <p className="paragraph m-0">{para?.para}</p>
                                    <ul className="mt-3 page-custom-made-application-list">
                                        {para?.list?.map((para, paraIndex) => (
                                            <li key={paraIndex}>
                                                {para?.text && <p className="paragraph m-0">{para?.text} </p>}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            })}
                            {li?.BetterWay && (
                                <div>
                                    <h5 className="heading">{li?.BetterWay?.title}</h5>
                                    {li?.BetterWay?.paragraph?.map((ex, exIndex) => {
                                        return (
                                            <p key={exIndex} className='paragraph'>{ex?.para}</p>
                                        )
                                    })}
                                </div>
                            )}
                        </div>)
                    })
                )}
            </div>
        </div>
    )
}
export default HiringDevelopers
